import { ChangeDetectionStrategy, Component, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { LayoutAlignDirective, LayoutDirective, LayoutGapDirective } from '@ngbracket/ngx-layout/flex';

@Component({
  selector: 'bt-map-save-controls',
  templateUrl: './map-save-controls.component.html',
  styleUrls: ['./map-save-controls.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    LayoutAlignDirective,
    LayoutDirective,
    LayoutGapDirective,
    MatButton
  ]
})
export class MapSaveControlsComponent {
  @Output('save') saveEmitter: EventEmitter<any> = new EventEmitter();
  @Output('cancel') cancelEmitter: EventEmitter<any> = new EventEmitter();

  save() {
    this.saveEmitter.emit();
  }

  cancel() {
    this.cancelEmitter.emit();
  }
}
